import _ from "lodash";
import Intro from "./Intro";
import { useBookStore } from "stores/bookStore";
import { useAppStore } from "stores/appStore";
import { DOCUMENT_CATEGORY_KI_NANG_SO } from "consts/book";
import { isMobile } from "react-device-detect";

export default function SectionGioiThieuTapHuanSGK() {
	const documents = useBookStore((state) => state.documents);
	const subjectId = useAppStore((state) => state.subjectId);
	const gradeId = useAppStore((state) => state.gradeId);
	const documentsOfCurrentGrade = _.get(documents, [gradeId], []);
	
	const gtsDocuments = documentsOfCurrentGrade.filter(
		(item) =>
			item.category === DOCUMENT_CATEGORY_KI_NANG_SO &&
			item.subject_id === subjectId
	);
	
	return (
		!_.isEmpty(gtsDocuments) && (
			<div className="col-md-12 result">
				<Intro
					data={gtsDocuments}
					categoryBook="Tài liệu bổ trợ"
					col={"col-" + (isMobile ? 6  : 2) }
					background="#fff"
				/>
			</div>
		)
	);
}
